import React from "react";

const isArray = <T,>(x: unknown): x is T[] => x instanceof Array;
const isString = (x: unknown): x is string => new String(x) instanceof String;

export const FacetsSelected: React.FC<FiltersSelectedProps> = ({ selectedFilters, handleRemove }) => {
  const chip = (value: string, key: string) => {
    return (
      <span className=" chip" onClick={() => handleRemove(key)}>
        {value}
      </span>
    );
  };
  return (
    <div className="active-facets">
      {selectedFilters.map((filter: SelectedFilter) => {

        if (isArray(filter.value)) {
          return filter.value.map((item) => chip(item, filter.key));
        } else if (isString(filter.value)) {
          return chip(filter.value, filter.key);
        } else {
          Object.keys(filter.value).forEach(function (key) {
            return chip(filter.value[key], filter.key);
          });
        }
      })}
    </div>
  );
};

interface FiltersSelectedProps {
  selectedFilters: Array<SelectedFilter>;
  handleRemove: (filterKey: string) => void;
}
interface SelectedFilter {
  key: string;
  label: string;
  value: Array<string> | string | { start: number; end: number };
}
